// Redux Action CONSTANTS
import * as actionTypes from "./actionTypes";

// Ajax Methods
import ajaxMethods from "../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../api/ajax-endpoints";
import { appInsights } from "../../config/appInsights";

export const getFaqStart = () => {
  return { type: actionTypes.GET_FAQ_START };
};

export const getFaqSuccess = (faqData) => {
  return { type: actionTypes.GET_FAQ_SUCCESS, faqData };
};

export const getFaqFailure = (error) => {
  return { type: actionTypes.GET_FAQ_FAILURE, error };
};

export const getFaqs = () => {
  return function (dispatch) {
    dispatch(getFaqStart());
    ajaxMethods
      .get(ajaxEndpoints.FAQS)
      .then((response) => {
        dispatch(getFaqSuccess(response));
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "faqs.js",
          },
        });
        dispatch(getFaqFailure(error));
      });
  };
};
